<template>
    <DModal
        :show="showModal"
        :title="__('tools.price_adjustments.buttons.add')"
        is-confirm
        @close="$emit('close-modal')"
        @confirm="submitForm"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('tools.price_adjustments.table.adjustment_rate')"
                is-required
                :error="errors.adjustment_rate"
                :hint="__('tools.price_adjustments.table.adjustment_rate_hint')"
            >
                <DInput
                    id="adjustment_rate"
                    v-model="form.adjustment_rate"
                    :is-valid="isFormFieldValid('adjustment_rate')"
                    type="number"
                    step="0.01"
                />
            </DFormRow>
            <DFormRow
                :label="__('tools.price_adjustments.table.valid_from')"
                :error="errors.valid_from"
                :hint="__('tools.price_adjustments.table.valid_from_hint')"
            >
                <DInput
                    id="valid_from"
                    v-model="form.valid_from"
                    :is-valid="isFormFieldValid('valid_from')"
                    type="date"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>
export default {
    name: 'PriceAdjustmentsCreateModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        priceAdjustment: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                adjustment_rate: this.priceAdjustment.adjustment_rate ?? null,
                valid_from: this.priceAdjustment.valid_from ?? null
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
